import { CollapseType } from '@meitu/saas-editor-ui/es/types';
import BackgroundCollapse from './views/background-collapse/background-collapse';
import BrushCollapse from './views/brush-collapse/brush-collapse';
import LayerCollapse from './views/layer-collapse/layer-collapse';
import MaterialCollapse from './views/material-collapse/material-collapse';
import MineCollapse from './views/mine-collapse/mine-collapse';
import MoreCollapse from './views/more-collapse/more-collapse';
import NavigationCollapse from './views/navigation-collapse/navigation-collapse';
import ShortcutCollapse from './views/shortcut-collapse/shortcut-collapse';
import TextCollapse from './views/text-collapse/text-collapse';

export const collapseConf: Record<string, React.ReactNode> = {
    [CollapseType.SHORTCUT_MENU]: <ShortcutCollapse />,
    [CollapseType.TEXT_MENU]: <TextCollapse />,
    [CollapseType.NAVIGATOR_MENU]: <NavigationCollapse />,
    [CollapseType.MORE_MENU]: <MoreCollapse />,
    [CollapseType.BRUSH_MENU]: <BrushCollapse />,
    [CollapseType.ELEMENT_MENU]: <MaterialCollapse />,
    [CollapseType.BACKGROUND_MENU]: <BackgroundCollapse />,
    [CollapseType.LAYER_MENU]: <LayerCollapse />,
    [CollapseType.MINE_MENU]: <MineCollapse />,
};
// 需要重置刷新接口的面板
export const refreshCollapseConf: Record<string, React.ReactNode> = {};
// 需要默认加载的面板
export const defaultCollapse: string[] = [CollapseType.LAYER_MENU, CollapseType.MINE_MENU];
/**
 * 折叠面板背景配置
 *
 * - `''`: 白色背景
 * - `'secondary'`: 无白色背景
 */
export const collapseBackgroundConf: Record<string, string> = {
    [CollapseType.MINE_MENU]: '',
    [CollapseType.SHORTCUT_MENU]: '',
    [CollapseType.TEXT_MENU]: '',
    [CollapseType.NAVIGATOR_MENU]: '',
    [CollapseType.TEMPLATE_MENU]: '',
    [CollapseType.MORE_MENU]: '',
    [CollapseType.BRUSH_MENU]: '',
    [CollapseType.LAYER_MENU]: '',
};
